<template>
  <div class="basic-card" :style="styleName">
    <div :style="innerStyle" :class="{ 
      'card-padding': padding,
      'reset-search-menu-margin': hasMore,
      'hide_avue_crud_header': hideHeader,
      'hide_avue_crud_pagination': hidePagination,
      }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'basicCard',
  props: {
    padding: {
      type: Boolean,
      default: false,
    },
    hasMore: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    radius: {
      type: [String, Number],
      default: 6,
    },
    style: {
      type: Object,
      default() {
        return {}
      }
    },
    innerStyle: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    styleName() {
      return {
        borderRadius: `${this.radius}px`,
        ...this.style,
      };
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
